export default {"src":"/_next/static/media/play.e0b5b9c4.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};